import BaseSender from './BaseSender';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose, getContext, branch, mapProps } from 'core/libs/recompose';

import { callYaMetrikaMethod } from 'core/utils/counters-helper';

class YandexMetrikaGoalSender extends PureComponent {
  static propTypes = {
    /** Событие, которое будет отправлятся по клику. */
    click: PropTypes.string,

    /** Событие, которое будет отправлятся при показе. */
    show: PropTypes.string,

    /** Параметры , которое будет отправлятся по клику. */
    params: PropTypes.object,

    /**
     * checkScrollY = true делает так, что обзервер не будет инициализироваться если компонент попадет в viewport когда scrollY=0,
     * это нужно для компонентов, которые находятся после большого контента и пока контент находится в состоянии загрузки они могут
     * подскочить вверх и произойдет ложное срабатывание
     */
    checkScrollY: PropTypes.bool,

    /**
     * По умолчанию событие отправляется только если клик сделан
     * по ссылке (`<a>`). Этот проп позволяет отключить проверку и
     * отправлять событие при клике по любому элементу.
     */
    skipTargetCheck: PropTypes.bool,

    /**
     * Список ids для которых будет передеаваться метрика.
     * Используется, если не нужно отправлять события по всем `context.countersIds`.
     */
    ids: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
  };

  onShow = () => {
    callYaMetrikaMethod(this.props.ids, 'reachGoal', this.props.show, this.props.params);
  };

  onClick = () => {
    callYaMetrikaMethod(this.props.ids, 'reachGoal', this.props.click, this.props.params);
  };

  render() {
    const {
      /* eslint-disable no-unused-vars */
      ids,
      /* eslint-enable no-unused-vars */
      children,
      show,
      click,
      ...otherProps
    } = this.props;

    return (
      <BaseSender
        onShow={show && this.onShow}
        onClick={click && this.onClick}
        {...otherProps}
      >
        {children}
      </BaseSender>
    );
  }
}

const YandexMetrikaGoalSenderWithHOCs = compose(
  branch(
    ({ ids }) => (!ids),
    getContext({ counterIds: PropTypes.object })
  ),
  mapProps(
    (props) => {
      return {
        ...props,
        ids: typeof props.counterIds === 'object' ?
          props.counterIds.yandexMetrika :
          props.ids,
      };
    }
  )
)(YandexMetrikaGoalSender);
YandexMetrikaGoalSenderWithHOCs.displayName = 'YandexMetrikaGoalSender';

export { YandexMetrikaGoalSender as StorybookComponent };
export default YandexMetrikaGoalSenderWithHOCs;
